import axios from "axios";
import { getHeader, getToken } from "@/helpers/functions";

const header = getHeader(getToken("ifragasatt_cookie"));

const state = {
  myComments: [],
  myCommentCount: 0,
  visitedComments: [],
};

const mutations = {
  setMyComments: (state, payload) => (state.myComments = payload),
  setMyCommentCount: (state, payload) => (state.myCommentCount = payload),
  setVisitedComments: (state, payload) => (state.visitedComments = payload)
};

const actions = {
  getMyComments({ commit, dispatch }, payload) {
    const url = `${process.env.VUE_APP_MY_COMMENTS}/?pageSize=${payload.size}&offset=${payload.offset}&sorting=${payload.sorting}`;

    dispatch("setIsLoading", true);

    axios
      .get(url, header)
      .then(res => {
        commit("setMyComments", res.data.myComments);
        commit("setMyCommentCount", res.data.total);
      })
      .catch(err => {
        console.error(err);
        dispatch("showToast", { message: "errors.COMMENTS_FETCH_FAILED", type: "error" });
      })
      .finally(() => dispatch("setIsLoading", false));
  },
  setMyComments({ commit }, payload) {
    commit("setMyComments", payload);
  },
  setMyCommentCount({ commit }, payload) {
    commit("setMyCommentCount", payload);
  },
  setVisitedComments({ commit }, payload) {
    commit("setVisitedComments", payload);
  }
};

const getters = {
  myComments: state => state.myComments,
  myCommentCount: state => state.myCommentCount,
  visitedComments: state => state.visitedComments,
  discussions: state => state.discussions
};

export default {
  state,
  actions,
  mutations,
  getters
};
